import Page from "components/Page";

const RejectedView = () => {
  return (
    <Page title="Join Waboba Supply Chain">
      <div className="p-10">
        <div>
          <h2 className="text-2xl font-bold mb-4">
            非常感谢您申请加入 Waboba 供应链！
          </h2>
          <p>
            很遗憾地通知您，经过我们的审核，您的申请未能通过。我们理解这可能会让您感到失望，但请相信，这一决定是基于多方面的考虑，以确保我们供应链的质量和稳定性。We
            regret to inform you that after our review, your application has not
            been approved. We understand that this may be disappointing, but
            please trust that this decision is based on multiple considerations
            to ensure the quality and stability of our supply chain.要
          </p>
          <p>
            如有任何疑问或需要进一步协助，请随时联系我们的供应商管理团队。If you
            have any questions or need further assistance, please feel free to
            contact our supplier management team.
          </p>
        </div>
      </div>
    </Page>
  );
};

export default RejectedView;
